import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import moment from "moment";
import { AppColors } from "../../../../util/AppColors";

const PharmacyDetailsHeader = ({ record, onBack }) => {
  if (!record) return null;

  return (
    <Box display="flex" flexDirection="column" gap={2} sx={{ width: "100%" }}>
      {/* Back Button */}
      <Box display="flex" alignItems="center">
        <button
          onClick={onBack}
          style={{
            backgroundColor: "#fff",
            color: "#616161",
            border: "1px solid #dcdada",
            borderRadius: "6px",
            height: "36px",
            padding: "0 16px",
            fontSize: "14px",
            fontWeight: "600",
            fontFamily: "Montserrat",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            boxShadow: "none"
          }}
        >
          <KeyboardBackspaceIcon sx={{ width: 18, height: 18 }} />
          Back to Pharmacy
        </button>
      </Box>

      {/* Case Details Card */}
      <Paper
        elevation={0}
        sx={{
          padding: "20px 24px",
          borderRadius: "12px",
          border: "1px solid #e0e0e0",
          backgroundColor: "#fff",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)"
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            fontSize: "18px",
            color: "#1c2434",
            fontFamily: "Montserrat",
            mb: 1.5
          }}
        >
          Case ID – {record.caseId ?? `CASE-${record.id}`} · {record.consultationType ?? "Consultation"}
        </Typography>

        <Box display="flex" alignItems="center" gap={3} flexWrap="wrap">
          {/* Date */}
          <Box display="flex" alignItems="center" gap={0.8}>
            <CalendarTodayIcon sx={{ color: "#e06666", width: 18, height: 18 }} />
            <Typography
              variant="body2"
              sx={{
                fontWeight: 600,
                color: "#4a4a4a",
                fontFamily: "Montserrat"
              }}
            >
              {record.date ? moment(record.date).format("DD MMM YYYY") : "15 Feb 2026"}
            </Typography>
          </Box>

          {/* Time */}
          <Box display="flex" alignItems="center" gap={0.8}>
            <AccessTimeIcon sx={{ color: "#f1c232", width: 18, height: 18 }} />
            <Typography
              variant="body2"
              sx={{
                fontWeight: 600,
                color: "#4a4a4a",
                fontFamily: "Montserrat"
              }}
            >
              {record.time ?? "13:40"}
            </Typography>
          </Box>

          {/* Vet */}
          <Box display="flex" alignItems="center" gap={0.8}>
            <PersonOutlineIcon sx={{ color: AppColors.appPrimary, width: 20, height: 20 }} />
            <Typography
              variant="body2"
              sx={{
                fontWeight: 600,
                color: "#4a4a4a",
                fontFamily: "Montserrat"
              }}
            >
              {record.veterinarian?.replace("Dr. ", "") ?? "Vivek"}
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default PharmacyDetailsHeader;
